import Seo from "./Seo";
import { MaskReveal } from "./Reveal";

export function LegalShell({ seoTitle, seoDescription, kicker, title, updated, children }) {
  return (
    <>
      <Seo title={seoTitle} description={seoDescription} />
      <section className="relative overflow-hidden bg-charcoal pt-40 pb-16 text-cream grain">
        <div className="relative z-10 mx-auto max-w-4xl px-5 lg:px-10">
          <p className="kicker text-gold">{kicker}</p>
          <h1 className="mt-6 font-serif text-5xl leading-[1] md:text-6xl">
            <MaskReveal lines={[title]} />
          </h1>
          {updated && <p className="mt-6 text-sm text-cream/60">Last updated: {updated}</p>}
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-5 py-16 lg:px-10 md:py-24">
        <div className="space-y-10">{children}</div>
      </section>
    </>
  );
}

export function Section({ heading, children }) {
  return (
    <div>
      {heading && <h2 className="font-serif text-2xl text-ink md:text-3xl">{heading}</h2>}
      <div className="mt-4 space-y-4 leading-relaxed text-stone">{children}</div>
    </div>
  );
}

export function P({ children }) {
  return <p className="leading-relaxed text-stone">{children}</p>;
}

export function UL({ items }) {
  return (
    <ul className="ml-1 space-y-2">
      {items.map((it, i) => (
        <li key={i} className="flex gap-3 text-stone">
          <span className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-gold" />
          <span>{it}</span>
        </li>
      ))}
    </ul>
  );
}
